import { storefront } from './sections/storefront.de-courses';
import { account } from './sections/account.de-courses';
import { admin } from './sections/admin.de-courses';

export const de = { ...storefront, ...account, ...admin };
